<template>
  <div style="padding:20px 30px">
    <post-management
      :base-form-url="baseUserUrl"
      :base-url="baseUrl"
      :request="request"
      :node="node"
      :showPhone='showPhone'
    ></post-management>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';
export default {
  computed: {
    ...mapGetters(["serveUrl", "request"]),
    baseUrl() {
      return configR.envConfigs.PERSON_CENTER_API;
    },
    baseUserUrl() {
      return configR.envConfigs.FORMFLOW_API_URL;
    },
    showPhone(){
      return configR.envConfigs.SCHOOL_CODE=='xigongda'?true:false
    }
  },
  data() {
    return {
      node: () => window,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.node = () => document.querySelector(".app-main-wrapper")[0];
    });
  },
};
</script>
